import classNames from 'classnames'
import Text from 'components/Text'
import './HighlightedLoader.scss'

const HighlightedLoader = ({ isLoading, loaderText }) => {
  const handleAriaHidden = (text) => {
    const textSplit = text.split('|')

    const textP1 = textSplit[0]
    const hiddenText = textSplit[1]

    return (
      <>
        {textP1} <span aria-hidden={true}>{hiddenText}</span>
      </>
    )
  }

  return (
    <section
      aria-hidden={!isLoading}
      className={classNames('section-highlighted-loader', {
        '--hide': !isLoading,
      })}
      aria-label={`${loaderText?.introText || ''} ${
        loaderText?.mainText || ''
      }`}
      aria-live="polite"
      aria-busy="true"
      tabIndex="0"
    >
      {loaderText?.introText && (
        <Text h1 className="section-highlighted-loader__text">
          {loaderText?.introText}
        </Text>
      )}
      {loaderText?.mainText && (
        <Text
          h2
          className="section-highlighted-loader__text section-highlighted-loader__text--bold"
        >
          {handleAriaHidden(loaderText?.mainText)}
        </Text>
      )}
      <div className="highlighted-loader-wrapper">
        <svg className="loader-circular" viewBox="25 25 50 50">
          <circle
            className="circle"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
            data-contrast="loader"
          />
        </svg>
      </div>
    </section>
  )
}

export default HighlightedLoader
